import styled, { css } from 'styled-components';
import { CopyFineprintSkin } from './CopytextSkins';
import getHeadlineSkin from '~/helpers/getHeadlineSkin';
import getSpacing from '~/helpers/getSpacing';
import { mq } from '~/styles/grid';
import CTAinlineLinks from '../CTA/skins/CTA.links';

const listPadding = 30;

export const CopyTextBasicStyling = css`
  h2 {
    ${(props) => getHeadlineSkin(props.theme.skinMap.heading.h2)}
  }

  h3 {
    ${(props) => getHeadlineSkin(props.theme.skinMap.heading.h3)}
  }

  h4 {
    ${(props) => getHeadlineSkin(props.theme.skinMap.heading.h4)}
  }

  h5 {
    ${(props) => getHeadlineSkin(props.theme.skinMap.heading.h5)}
  }

  h6 {
    ${(props) => getHeadlineSkin(props.theme.skinMap.heading.h6)}
  }

  a {
    ${CTAinlineLinks};
  }

  small {
    ${CopyFineprintSkin};
    display: inline-block;
  }

  b,
  strong {
    font-family: ${(props) => props.theme.font.bold};
    font-weight: 700;
  }

  i,
  em {
    font-style: italic;
  }

  li + li {
    ${(props) => getSpacing(props.theme.spacingMap.richtext.li, 'mtop')};
  }

  ul li {
    position: relative;
    padding-left: ${listPadding}px;

    &:before {
      content: '';
      position: absolute;
      border-radius: 50%;
      height: 3px;
      width: 3px;
      background: ${(props) => props.theme.color.primary800};
      left: 3px;
    }

    @media (${mq.xs}) {
      padding-left: 20px;
    }
  }

  ol {
    position: relative;
    padding-left: ${listPadding}px;
    counter-reset: fresenius-counter;

    li {
      position: relative;
      counter-increment: fresenius-counter;

      &:before {
        content: counter(fresenius-counter) '. ';
        color: ${(props) => props.theme.color.primary800};
        font-weight: 700;
        position: absolute;
        text-align: right;
        left: -${listPadding}px;
        width: ${listPadding - 10}px;
        font-size: ${(props) => props.theme.copytext.copyFineprint.fontSize};
        line-height: 1.9;
      }

      > ol {
        margin-top: 0;
        margin-bottom: 0;
        counter-reset: fresenius-alpha;

        > li {
          counter-increment: fresenius-alpha;

          &:before {
            text-align: left;
            content: counter(apo-alpha, lower-alpha) '. ';
            left: -${listPadding}px;
          }
        }
      }
    }
  }
`;

export const CopyTextStyled = styled.div`
  ${CopyTextBasicStyling};
`;
